import React from 'react';
import { observer, inject } from 'mobx-react';

const Checkbox = observer((props) => {
  const onChange = (event) => {
    props.store[props.column.action](props.row);
  };
  return (
    <td className="base-td">
      <div className="td-content" style={{ width: props.column.width }}>
        <div className="checkbox-content">
          <input type="checkbox" checked={props.row[props.column.checkedFieldName]} onChange={onChange} />
        </div>
      </div>
    </td>
  );
});

const DoubleCheckbox = observer((props) => {
  const onChange = (event, fieldName) => {
    const isChecked = event.target.checked;
    props.store[props.column.action](props.row, isChecked, fieldName);
  };

  const onChangeFirstCheckbox = (event) => {
    onChange(event, props.column.firstFieldName);
  };

  const onChangeSecondCheckbox = (event) => {
    onChange(event, props.column.secondFieldName);
  };

  return (
    <td className="base-td">
      <div className="td-content double-checkbox-content" style={{ width: props.column.width }}>
        <div className="double-checkbox-content-entry">
          {props.row[props.column.firstHasFieldName] && (
            <input
              type="checkbox"
              onChange={onChangeFirstCheckbox}
              checked={props.row[props.column.firstFieldName]}
              disabled={props.row[props.column.fisrtFieldDisabledName]}
            />
          )}
        </div>
        <div className="double-checkbox-content-entry">
          {props.row[props.column.secondHasFieldName] && (
            <input
              type="checkbox"
              onChange={onChangeSecondCheckbox}
              checked={props.row[props.column.secondFieldName]}
              disabled={props.row[props.column.secondFieldDisabledName]}
            />
          )}
        </div>
      </div>
    </td>
  );
});

const TradingVenueDoubleCheckbox = inject('tradingVenuesStore')((props) => {
  return <DoubleCheckbox store={props.tradingVenuesStore} {...props} />;
});

const TradingVenueGroup = (props) => {
  return (
    <td className="base-td business-group">
      <div className="td-content business-content" style={{ width: props.column.width }}>
        {props.rowWithGroupCell && <div className={`business-group-icon ${props.row[props.column.imgField]}`} />}
      </div>
    </td>
  );
};

const cellTemplates = {
  checkbox: Checkbox,
  doubleCheckbox: DoubleCheckbox,
  tradingVenueGroup: TradingVenueGroup,
  tradingVenueDoubleCheckbox: TradingVenueDoubleCheckbox
};

export default cellTemplates;



// WEBPACK FOOTER //
// ./src/common/core/grid/gridCellTemplates.js